import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { CreditCardPaymentComponent } from './creditcard-payment/creditcard-payment.component';
import { NotFoundComponent } from './error/not-found.component';
import { CreditCardPaymentDeclineComponent } from './creditcard-payment/creditcard-payment-decline.component';
import { CreditCardPaymentSuccessComponent } from './creditcard-payment/creditcard-payment-success.component';
import { OrderService } from './creditcard-payment/order.service';
import { HttpClientModule } from '@angular/common/http';
import { InternalServerErrorComponent } from './error/internal-server-error.component';
import { CartPaymentService } from './creditcard-payment/card-payment.service';
import { CardPaymentHostedTokenErrorComponent } from './error/card-payment-hosted-token-error.component';
import { ServiceUnavailableComponent } from './error/service-unavailable.component';
import { LoadingScreenService } from './common/loading/loading-screen.service';
import { LoadingScreenComponent } from './common/loading/loading-screen.componenent';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CreditCardPaymentComponent,
    CreditCardPaymentDeclineComponent,
    CreditCardPaymentSuccessComponent,
    NotFoundComponent,
    InternalServerErrorComponent,
    ServiceUnavailableComponent,
    CardPaymentHostedTokenErrorComponent,
    LoadingScreenComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
    OrderService,
    CartPaymentService,
    LoadingScreenService,
    HttpClientModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
